export const imageSizeLabels = {
    squareImage: "Imagen cuadrada",
    tripleImage: "Imagen response",
    customImage: "Imagen personalizada"
};

export const imageSizeLabel = (size) => imageSizeLabels[size] || size;

export const sizesImages = [
    {
        size: "squareImage",
        title: "Cuadrada",
        width: 1200,
        height: 1200,
        strict: true
    },
    {
        size: "customImage",
        title: "Personalizado",
        width: 4200,
        height: 4200,
        strict: false
    }
];

export const sizesImagesAll = [
    {
        size: "squareImage",
        title: "Cuadrada",
        icon: "🖼️",
        description:
            "Se optimiza automáticamente en 3 tamaños para que el catálogo cargue rápido. Ideal para productos, marcas y tiendas.",
        sizes: [
            { size: "squareImage", width: 1200, height: 1200, strict: true }
        ]
    },
    {
        size: "tripleImage",
        title: "Response",
        icon: "🖥️",
        description:
            "Tres imágenes, una por tamaño de pantalla (computador, tablet y celular). Ideal para banners.",
        sizes: [
            { size: "largeImage", width: 1400, height: 600, strict: true },
            { size: "normalImage", width: 778, height: 600, strict: true },
            { size: "smallImage", width: 480, height: 480, strict: true }
        ]
    },
    {
        size: "customImage",
        title: "Personalizada",
        icon: "🎨",
        description:
            "Se sube tal cual, sin optimización. Úsala para el contenido de tus páginas.",
        sizes: [
            { size: "customImage", width: 4200, height: 4200, strict: false }
        ]
    }
];

const SIZE_FILTER_NAMES = {
    squareImage: "cuadradas",
    tripleImage: "response (para banners)",
    customImage: "personalizadas"
};

// Texto del chip que avisa que la galería está filtrada por tamaño.
export const imageSizeFilterLabel = (size) => {
    const name = SIZE_FILTER_NAMES[size] || `de tipo ${imageSizeLabel(size)}`;
    const option = sizesImagesAll.find((item) => item.size === size);
    const dimensions = (option?.sizes || [])
        .filter((item) => item.strict)
        .map((item) => `${item.width} × ${item.height}`);
    if (!dimensions.length) return `Mostrando solo imágenes ${name}`;
    const list =
        dimensions.length > 1
            ? `${dimensions.slice(0, -1).join(", ")} y ${dimensions.slice(-1)}`
            : dimensions[0];
    return `Mostrando solo imágenes ${name} de ${list} px`;
};
